import React from "react";

/**
 * Icons come from `@animaliads/animalia-icon` — the real published Animalia
 * icon library, already a dependency of this site and already loaded globally
 * in the root layout. A design-system case study should draw its icons from
 * the system it is describing.
 */
const AniIcon = ({ name, className }: { name: string; className?: string }) => name.startsWith("figma-") ? (
  <span
    aria-hidden="true"
    className={`ani-asset-icon${className ? ` ${className}` : ""}`}
    style={{ maskImage: `url(/images/animalia/playground/${name.slice(6)}.svg)` }}
  />
) : (
  <i
    className={`an an-${name}${className ? ` ${className}` : ""}`}
    aria-hidden="true"
  />
);

export default AniIcon;
